import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/auth/service/user.service';
import { ActivityTrackerService } from 'src/app/services/activity-tracker.service';

@Component({
  selector: 'app-tracker',
  templateUrl: './tracker.component.html',
  styleUrls: ['./tracker.component.scss'],
})
export class TrackerComponent implements OnInit {
  userData: any;
  isLoading = false;

  trackerStatus: any;
  trackerSyncStatus: any;
  constructor(
    private userService: UserService,
    private activityTrackerService: ActivityTrackerService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.route.queryParams.subscribe((params) => {
      let oauth_token = params.oauth_token;
      let oauth_verifier = params.oauth_verifier;

      this.activityTrackerService
        .syncTracker('garmin')
        .subscribe((responseData) => {
          this.trackerSyncStatus = responseData;

          if (this.trackerSyncStatus != 'success') {
            this.activityTrackerService
              .setupTracker('garmin', oauth_token, oauth_verifier)
              .subscribe((responseData) => {
                this.trackerStatus = responseData;
                this.userService.reset();
                this.userService.get().subscribe((userData:any) => {
                });
              });
          }
        });
    });
  }
  
  onDisconnect(){
    this.activityTrackerService.disconnectTracker().subscribe((responseData)=>{
      console.log(responseData);
      this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => this.router.navigate(['/activity', 'tracker']));

    });
  }
}
